export default __webpack_public_path__ + "static/media/bg.e7ad6c45.png";